<template>
  <transition name="router-anim">
    <div>
      <section class="info-block-wrapper search">
        <div class="custom-alert">
          <strong>
             The QR code generator creates a QR code using the Kit ID as input. Scanning the QR code redirects to the kit activation page.
          </strong>
        </div>
        <div class="title search">
          <span>Generate QR Code</span>
        </div>
        <div class="input-div-wrap">
          <div class="input-wrap">
            <span class="radio-span">
              <input type="radio" name="qr_code" value="1" v-model="qr_type">KIT ID
            </span>
            <span>
              <input type="radio" name="qr_code" value="2" v-model="qr_type">URL
            </span>
          </div>
          <div class="input-wrap" v-show="qr_type == 1">
            <input
              v-mask="'XX - XX - XXX - XXXX'"
              id="kit-id"
              type="text"
              class="input"
              placeholder="Enter Kit ID"
              name="kit_id"
              v-model="kit_id"
              @keyup="checkKitId"
              @paste="paste"
              v-validate="{ required: true, length: 20 }"
            />
            <span class="validate-error position" v-if="errors.has('kit_id')">
              {{ setError(errors.first("kit_id")) }}
            </span>
          </div>
          <div class="input-wrap" v-show="qr_type == 2">
            <input
              type="text"
              class="input custom-lower-case"
              placeholder="Website address, Video URL, Affiliate Discount Link"
              name="custom_url"
              v-model="custom_url"
              @keyup="checkCustomUrl"
            />
          </div>
          <div>
              <button
                class="btn btn-test search"
                @click.prevent="$validator.validateAll()"
                @click="generateQrcode"
                :disabled="!isComplete"
              >
                Generate
              </button>
          </div>
          <div id="qr-image-wrap" class="img-wrap" v-if="url">
            <div class="qrcode-wrap">
              <qr-code :text="url" :size="300"></qr-code>
            </div>
            <div class="download-btn">
              <button
                  class="btn btn-test search"
                  @click="downloadQrcode"
                >
                Download
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </transition>
</template>

<script>
import { parseAndConvertKitId } from "../mixins/parseAndConvertKitId";
import { mapGetters } from "vuex";
import Vue from 'vue' 
import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

export default {
  name: "QRcode",
  mixins: [parseAndConvertKitId],
  data() {
    return {
      kit_id: null,
      qr_type: 1,
      isComplete: false,
      url: null,
      custom_url: null
    };
  },
  computed: {
    ...mapGetters(["serverValidation"]),
  },
  watch: {
    serverValidation(error) {
      error.forEach(item => {
        this.$validator.errors.add({ field: item.field, msg: item.message });
      });
    },
    qr_type() {
      this.isComplete = false;
      this.kit_id = null;
      this.custom_url = null;
      this.url = null;
    }
  },
  methods: {
    downloadQrcode() {
      const image = document.querySelector("#qr-image-wrap .qrcode-wrap img");
      const link = document.createElement('a');
      link.href = image.src;
      link.setAttribute('download', 'QRcode.png');
      document.body.appendChild(link);
      link.click();
    },
    generateQrcode() {
      if(this.qr_type == 1) {
        // const test = SubtleCrypto.encrypt(this.parseKitId(this.kit_id), 'encrypted_key')
        // console.log(test)
        let activate_url = 'https://my.gotmold.com/activate-kit/'+this.parseKitId(this.kit_id);
        this.url = activate_url;
      }else if(this.qr_type == 2){
        this.url = this.custom_url;
      }
    },
    paste(e) {
      e.preventDefault();
    },
    setError(str) {
      if (str === "exists validation failed on kit_id") {
        return "Can’t find this Kit ID.";
      }

      if(str === "Your Kit ID is required..") {
        return "Kit ID is required..";
      }
      
      return str;
    },
    checkKitId() {
      if(this.kit_id != null && this.kit_id.length == 20) {
        this.isComplete = true
      }else{
        this.isComplete = false
      }
    },
    checkCustomUrl() {
      if(this.custom_url.length > 0) {
        this.isComplete = true
      }else{
        this.isComplete = false
      }
    }
  },
  
};
</script>

<style scoped lang="scss">
@import "../../styles/colors";
.kits {
  margin: 50px 0 0 0;
}
.description-modal{
  text-align: start;
  position: absolute;
  top: 7px;
  left: 5px;
}
.kits-title {
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px 0;
  padding: 0 30px;
}
.title {
  color: #b3b3b3;
  font-size: 12px;
  font-family: TTNormsMedium, sans-serif;
}
.title.id {
  min-width: 120px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.id {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
  cursor: pointer;
  transition: all 0.5s linear;
}
.kit-desc.id:hover {
  color: #005eb8;
  font-family: TTNormsRegular, sans-serif;
}
.title.status {
  min-width: 170px;
  width: 100%;
  max-width: 170px;
}
.kit-desc.status {
  min-width: 170px;
  width: 100%;
  max-width: 170px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.title.first-name {
  min-width: 130px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.first-name {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.title.last-name {
  min-width: 130px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.last-name {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.title.email {
  min-width: 190px;
  width: 100%;
  max-width: 190px;
}
.kit-desc.email {
  min-width: 190px;
  width: 100%;
  max-width: 190px;
  overflow: hidden;
  padding: 0 5px 0 0;
}
.kit-desc.email span {
  width: 100%;
  max-width: 180px;
  overflow: hidden;
  display: inline-block;
}
.kit-desc.first-name span,
.kit-desc.last-name span {
  width: 100%;
  max-width: 140px;
  overflow: hidden;
  display: inline-block;
}
.title.phone {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.phone {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.title.date {
  min-width: 100px;
  width: 100%;
  position: relative;
//   cursor: pointer;
  max-width: 180px;
}
.title.date2 {
  min-width: 160px;
  width: 100%;
  position: relative;
//   cursor: pointer;
}
.title.date img {
  max-width: 7px;
  height: 14px;
  position: absolute;
  top: -3px;
  right: 5px;
}
.title.date .down {
  transform: rotate(180deg);
}
.kit-desc.date {
  min-width: 160px;
  width: 100%;
}
.kit-desc.button {
  min-width: 160px;
  width: 100%;
}
.kits-item {
  justify-content: space-between;
  position: relative;
  align-items: center;
  padding: 25px 30px;
  background-color: #fff;
  margin: 10px 0;
  border-radius: 5px;
}
.kits-item.custom {
  text-align: center;
  display: ruby block;
}
.btn-align {
  margin-top: 20px;
  text-align: center;
  display: block ruby;
}
.kits-item:hover {
  background-color: #e0e9f4;
}
.kits-item:hover .remove-kit-btn {
  display: block;
}
.kit-desc {
  color: #58595b;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
}
.status-line {
  width: 100%;
  max-width: 140px;
  height: 3px;
  background-color: rgba(0, 70, 173, 0.3);
  margin: 5px 0 0 0;
  position: relative;
}
.status-line-bg {
  position: absolute;
  width: 50%;
  content: "";
  left: 0;
  top: 0;
  height: 100%;
  background-color: #005eb8;
}
.pogination {
  margin: 20px 0 0 0;
}
.remove-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  padding: 0;
}
.onhold-btn {
  background-color: transparent;
  border: none;
  padding: 0;
  max-width: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  margin: 0 0 0 5px;
  cursor: pointer;
}
.onhold-btn-img {
  max-width: 100%;
}
.onHoldStatus {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.remove-kit-btn {
  display: none;
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1px solid #58595b;
  border-radius: 5px;
  right: 20px;
  cursor: pointer;
  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
    height: 1px;
    width: 13px;
    background-color: #58595b;
    top: 50%;
    left: 50%;
    transform: translate(-50%) rotate(45deg);
  }
  &:after {
    transform: translate(-50%) rotate(-45deg);
  }
  &:hover {
    border-color: red;
    &:before,
    &:after {
      background-color: red;
    }
  }
}
@media print {
  .kits {
    display: none;
  }
}
.btn {
  align-items: center;
  justify-content: center;
  outline: none;
  border: 1px solid transparent;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
  padding: 6px 15px 6px 15px;
  height: 30px;
  margin: 0 0 0 13px;
  cursor: pointer;
  border-radius: 5px;
}
.btn.search {
  height: 35px;
  min-width: 440px;
  margin: 0px;
}
.btn-test {
  background-color: #005eb8;
  color: #fff;
  max-width: 160px;
  width: 100%;
}
.title {
  color: #1052b2;
  padding: 20px 0 0 0;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  margin: 0 0 30px 0;
  display: flex;
  position: relative;
  justify-content: space-between;
}
.title.search {
  font-size: 20px;
  margin: 0 0 20px 0;
  display: inherit;
  padding: 0px;
}
.kit-input {
  padding: 0px 5px;
  border: 1px solid transparent;
  outline: none;
  color: #231f20;
  font-size: 14px;
  margin: 0 0 0 5px;
  display: inline-block;
  max-width: 200px;
  width: 100%;
  transition: border 0.3s linear;
  font-family: TTNormsLight, sans-serif;
}
.kit-input.input {
  text-align: center;
}
.item {
  margin: 0 0 25px 0;
  position: relative;
}
.item-title {
  margin: 0 0 14px 0;
  color: #000;
  font-size: 12px;
  font-family: TTNormsMedium, sans-serif;
}
.item-val {
  color: #000;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  position: relative;
}
.date-wrap {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #d9d9d9;
}
.date-wrap2 {
  display: flex;
  justify-content: space-between;
}
.margin-10 {
  margin-top: 10px;
}
.info-block-wrapper {
  width: 100%;
  min-height: 200px;
  box-sizing: border-box;
  padding: 40px 30px;
  display: block;
  justify-content: space-between;
  background-color: $white;
  border-radius: 15px;
  box-shadow: 0 3px 15px -9px $boxShadow;
  font-family: TTNormsRegular, sans-serif;
  color: $gray;
  margin: 10px 0;
  position: relative;
}
.info-block-wrapper.search {
  text-align: center;
}
.input {
  width: 440px;
  padding: 12px 30px;
  border-radius: 10px;
  border: 1px solid #c5c5c5;
  color: $gray;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
  outline: none;
  font-family: TTNormsMedium, sans-serif;
}
.textarea {
  width: 100%;
  min-height: 150px;
  padding: 12px 13px;
  border-radius: 10px;
  border: 1px solid #c5c5c5;
  color: $gray;
  font-size: 16px;
  outline: none;
  font-family: TTNormsMedium, sans-serif;
}
.input::placeholder {
  color: $lightGray;
  font-size: 16px;
  text-align: center;
  text-transform: none;
  font-family: TTNormsMedium, sans-serif;
}
.input-wrap {
  margin-bottom: 15px;
  position: relative;
}
.input.invalid {
  border: 1px solid $red;
}
.position {
  position: initial;
}
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
.or-text {
  font-size: 15px;
}
.radio-span {
  margin-right: 35px;
}
.img-wrap {
  margin-top: 20px;
  display: inline-block;
}
.input.custom-lower-case {
  text-transform: none;
}
.download-btn {
  margin-top: 20px;
}
.qrcode-wrap {
  padding-left: 16%;
}
.custom-alert {
    text-align: start;
    background-color: #d4edda;
    color: #155724;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #c3e6cb;
    font-family: TTNormsLight, sans-serif;
    margin-bottom: 20px;
  }
</style>
